(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["scheduled-announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scheduled-announcement')) customElements.define('scheduled-announcement', class extends HTMLElement {
    connectedCallback() {
      const update = () => {
        const now = Date.now(), start = Date.parse(this.dataset.start), end = Date.parse(this.dataset.end);
        const active = now >= start && now < end;
        this.dataset.active = String(active);
        const text = active ? this.dataset.offer : this.dataset.fallback;
        if (this.textContent !== text) this.textContent = text;
      };
      update();
      this.timer = setInterval(update, 15000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
  } catch(e) { console.error(e); }
})();

})();
